import { render } from "./WiseNotificationModal.vue?vue&type=template&id=e599458a"
import script from "./WiseNotificationModal.vue?vue&type=script&lang=js"
export * from "./WiseNotificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__